import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
  Typography
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";
import { useTranslation } from "react-i18next";

const ConsolidateAccountTransactionTableFilter = (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [transactionProcessTypeSelect, setTransactionProcessTypeSelect] =
    useState({
      data: [],
      loading: false,
    });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [transactionTypeSelect, setTransactionTypeSelect] = useState({
    data: [],
    loading: false,
    query: "",
  });
  const [tagSelect, setTagSelect] = useState({
    data: [],
    loading: false,
  });

  const [tenantSelect, setTnantSelect] = useState({
    data: [],
    loading: false,
  });
  const [tenantAccountSelect, setTenantAccountSelect] = useState({
    data: [],
    loading: false,
  });

  const [groupId, setGroupId] = useState("");

  useEffect(() => {

    if (props.data && props.groupId) {

     if (props.data.transactionDateMin && props.data.transactionDateMax) {

        props.data.transactionDateRange = [
          moment(props.data.transactionDateMin),
          moment(props.data.transactionDateMax),
        ];
      }
      
     
      setGroupId(props.groupId);

      getBanks(props.groupId);
      getTenants(props.groupId);
      getCurrencies();
      getTransactionProcessTypes();
      getTransactionTypes();
      getTags();

      
      form.setFieldsValue(props.data);
    }
  }, [props.data, props.groupId]);

  const getBanks = (groupId) => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/ConsolidateAccountTransaction/GetFilterBank?groupId=${groupId}`
    ).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };
  const getTenants = (groupId) => {
    setTnantSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/ConsolidateAccountTransaction/GetFilterTenant?groupId=${groupId}`
    ).then((response) => {
      setTnantSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onChangeTenantAccount = (value) => {
    if (value != undefined || value != null) {
      RequestHandler.get(
        `/ConsolidateAccountTransaction/GetFilterAccount?groupId=${groupId}&$filter=bankId eq ${value}`
      ).then((response) => {
        setTenantAccountSelect({
          data: response,
        });
      });
      form.resetFields(["tenantAccountId"]);
    } else {
      form.resetFields(["bankId", "tenantAccountId"]);
      setTenantAccountSelect({
        data: [],
      });
    }
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetByBankAccounts?$select=id,code`).then(
      (response) => {
        setCurrencySelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getTransactionProcessTypes = () => {
    setTransactionProcessTypeSelect({
      ...transactionProcessTypeSelect,
      loading: true,
    });
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTransactionProcessTypeSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/ConsolidateAccountTransaction/GetFilterFirm?groupId=${groupId}&$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const getTransactionTypes = () => {
    setTransactionTypeSelect({
      ...transactionTypeSelect,
      loading: true,
    });

    RequestHandler.get(`/AccountTransaction/GetTransactionType`).then(
      (response) => {
        setTransactionTypeSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getTags = () => {
    setTagSelect({
      ...tagSelect,
      loading: true,
    });

    RequestHandler.get(`/TenantTransactionTag/GetTransactionTagList`).then(
      (response) => {
        setTagSelect({
          data: response?.map((item) => item.tag),
          loading: false,
        });
      }
    );
  };

  const onTransactionTypeChange = (value) => {
    if (!value) {
      setTransactionTypeSelect({ ...transactionTypeSelect, query: "" });
      return;
    }

    RequestHandler.get(
      `/AccountTransaction/GetTransactionTypeGroup?ids=${value}`
    ).then((response) => {
      if (Array.isArray(response) && response.length > 0) {
        setTransactionTypeSelect({
          ...transactionTypeSelect,
          query: `transactionTypeId in (${response
            .map((item) => item.id)
            .join(",")})`,
        });
      }
    });
  };

  const getTagsQuery = (value) => {
    let query = "";

    value.map((item, index) => {
      if (value.length > 1) {
        if (index == value.length - 1) {
          query += ` transactionTags/any(s:endswith(s, '${item}'))`;
        } else {
          query += `transactionTags/any(s:endswith(s, '${item}')) OR `;
        }
      } else {
        query += `transactionTags/any(s:endswith(s, '${value}'))`;
      }
    });

    return query;
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.tenantIban) {
        conditions.push(odata.contains("tenantIban", values.tenantIban));
      }

      const amountQuery = odata.ConditionalRange(
        "amount",
        values.amountMin,
        values.amountMax
      );
      if (amountQuery) conditions.push(amountQuery);

      if (values.currencyId) {
        conditions.push(`currencyId eq ${values.currencyId}`);
      }

      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;

        if (props.isTransactionTimeFilter)
          conditions.push(
            odata.dateTimeRange("transactionDateValue", startDate, endDate)
          );
        else
          conditions.push(
            odata.dateRange("transactionDateValue", startDate, endDate)
          );
      }

      if (values.tenantAccountId) {
        conditions.push(`tenantAccountId eq ${values.tenantAccountId}`);
      }
      if (values.tenantAccountName) {
        conditions.push(`tenantAccountName eq '${values.tenantAccountName}'`);
      }
      if (values.transactionProcessTypeValue) {
        conditions.push(
          `transactionProcessTypeValue eq ${values.transactionProcessTypeValue}`
        );
      }

      if (values.tcknVkn) {
        conditions.push(
          `${values.tcknVkn.length == 10 ? "vkn" : "tckn"} eq '${
            values.tcknVkn
          }'`
        );
      }

      if (values.tenantId) {
        conditions.push(`tenantId eq ${values.tenantId}`);
      }

      if (
        values.transactionTypeId &&
        values.transactionTypeId.length != 0 &&
        transactionTypeSelect.query
      ) {
        conditions.push(transactionTypeSelect.query);
      }

      if (values.tags) {
        conditions.push(getTagsQuery(values.tags));
      }

      if (values.description) {
        let filterText =
          "(" +
          odata.contains("description", values.description) +
          " or " +
          odata.contains("additionalDescription", values.description) +
          " or " +
          odata.contains("senderName", values.description) +
          ")";
        conditions.push(`${filterText}`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header={t("clickToFilter")}
             extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label={t("bank") + " :"}>
                    <Select
                      allowClear
                      showSearch
                      placeholder={t("allMini")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={bankSelect.loading}
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.text} value={item.text}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="tenantAccountId"
                    label={t("bankAccount") + " :"}
                  >
                    <Select
                      autoClearSearchValue
                      allowClear
                      showSearch
                      placeholder={t("allMini")}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {tenantAccountSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {(item.name ? item.name : "") +
                            " " +
                            (item.accountNumber
                              ? item.accountNumber
                              : item.iban === null
                              ? ""
                              : item.iban) +
                            "  (" +
                            item.tenantName +
                            ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="tenantAccountName"
                    label={t("accountName") + " :"}
                  >
                    <Select
                      autoClearSearchValue
                      allowClear
                      showSearch
                      placeholder={t("allMini")}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {tenantAccountSelect.data.map((item) => (
                        <Select.Option key={item.name} value={item.name}>
                          {(item.name ? item.name : "") +
                            " " +
                            (item.accountNumber
                              ? item.accountNumber
                              : item.iban === null
                              ? ""
                              : item.iban) +
                            "  (" +
                            item.tenantName +
                            ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="tcknVkn"
                    label={t("tcknOrVkn") + " :"}
                    rules={[
                      {
                        pattern: /^[0-9]{10,11}$/,
                        message: t("only10or11Digits"),
                      },
                    ]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    style={{ marginBottom: 0 }}
                    label={t("amount") + " :"}
                  >
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label={t("currency") + " :"}>
                    <Select
                      allowClear
                      showSearch
                      placeholder={t("allMini")}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ id, code }) => (
                        <Select.Option key={id} value={`${id}`}>
                          {code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionDateRange"
                    label={t("date") + " :"}
                  >
                    <DatePicker.RangePicker
                      format={
                        props.isTransactionTimeFilter
                          ? "DD.MM.YYYY HH:mm"
                          : "DD.MM.YYYY"
                      }
                      showTime={
                        props.isTransactionTimeFilter
                          ? {
                              hideDisabledOptions: true,
                              defaultValue: [
                                moment("00:00", "HH:mm"),
                                moment("23:59", "HH:mm"),
                              ],
                            }
                          : undefined
                      }
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="iban" label={t("counterIban") + " :"}>
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label={t("description") + " :"}>
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionProcessTypeValue"
                    label={t("paymentOrCollectionType") + " :"}
                  >
                    <Select
                      allowClear
                      placeholder={t("allMini")}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionProcessTypeSelect.loading}
                    >
                      {transactionProcessTypeSelect.data.map(
                        ({ key, value }) => (
                          <Select.Option key={key} value={key}>
                            {value}
                          </Select.Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="tenantId" label={t("tenant") + " :"}>
                    <Select
                      allowClear
                      showSearch
                      placeholder={t("allMini")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={tenantSelect.loading}
                    >
                      {tenantSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionTypeId"
                    label={t("transactionType") + " :"}
                  >
                    <Select
                      allowClear
                      showSearch
                      mode="multiple"
                      placeholder={t("allMini")}
                      onChange={onTransactionTypeChange}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionTypeSelect.loading}
                    >
                      {transactionTypeSelect.data.map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    {t("reset")}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    {t("filter")}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default ConsolidateAccountTransactionTableFilter;
